// extracted by mini-css-extract-plugin
module.exports = {"sell":"SellProduct_sell__2BHAr","title":"SellProduct_title__23MhT"};